import axios from 'axios';
import { getToken } from '../../utils/auth';
import { Toast } from 'antd-mobile'

// const isDev = process.env.NODE_ENV === 'development';
// const loginPath = '/user/login';
export const CODETYPE_TOKEN_INVALID_OR_EXPIRED = 500;

const jsRequest = axios.create({});

// 追加代理头 前置拦截器
jsRequest.interceptors.request.use(
  (config) => {
    // config.url = `/api${config.url}`;
    // config.url = `https://s.focusight.ltd${config.url}`;
    config.url = `https://s.focusight.top/jeecg-boot${config.url}`;
    return config;
  },
  (error) => Promise.reject(error),
);

// url模板拦截器 前置拦截器
jsRequest.interceptors.request.use(
  (config) => {
    /**
     * 输入
     * url: '/sco-admin/admin/business/area/deleteArea/{id}'
     * data: {id: 123}
     *
     * 输出：
     * url: '/sco-admin/admin/business/area/deleteArea/123'
     */
    const data = {
      ...(config.params || {}),
      ...(config.data || {}),
      ...(config.pathParams || {}),
    };
    config.url = config.url.replace(/\{(.+?)\}/g, (_, key) => data[key] || 'null');
    return config;
  },
  (error) => Promise.reject(error),
);

// // form-urlencoded 前置拦截器
// jsRequest.interceptors.request.use(
//   (config) => {
//     if (config.headers['Content-Type']?.includes('application/x-www-form-urlencoded')) {
//       // config.data = qs.stringify(config.data);
//       config.data = stringify(config.data);
//     }
//     return config;
//   },
//   (error) => Promise.reject(error),
// );

// 请求鉴权 前置拦截器
jsRequest.interceptors.request.use(
  (config) => {
    config.headers['x-access-token'] = `${getToken()}`;
    // config.headers['x-access-token'] = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3MzY5MDg5NTQsInVzZXJuYW1lIjoiMTU5Njc5MzU0NDYifQ.5yc6kS_JSB-_bO8HrLqIKg9PURRTAf0zCblvS-Igok8';
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  (error) => Promise.reject(error),
);

// 登录异常 后置拦截器
jsRequest.interceptors.response.use(
  (response) => {
    if (response.status === 401) {
      // 用户认证失败，执行退出登录
      localStorage.clear();
      // history.push(loginPath);
    }
    // [克隆响应对象做解析处理] https://github.com/umijs/umi-request/blob/HEAD/README_zh-CN.md#%E6%8B%A6%E6%88%AA%E5%99%A8
    // const res = await response.clone().json()
    const res = response.data;
    if (res.code === CODETYPE_TOKEN_INVALID_OR_EXPIRED) {
      // 用户认证失败，执行退出登录
      // localStorage.clear(); // 清除用户信息(退出登录)
      // history.push(loginPath);
      // setTimeout(() => {
      //   /**
      //    * todo 这里只是临时解法
      //    * app.jsx里的获取菜单函数只会在页面进入的时候更新，异常登出和正常登出后重进不会重新获取菜单，造成问题
      //    */
      //   window.location.reload()
      // }, 0)
      return response;
    }
    if (!res.success && res.message) {
      if (response.config.handleSelf) {
        response.handleSelf = response.config.handleSelf;
        return response;
      }
      // message.error(res.message);
      Toast.show({
        content: res.message,
        afterClose: () => {
          console.log('after')
        },
      })
      throw new Error(`jsRequestError: ${res.message}`);
    }
    return response;
  },
  (error) => Promise.reject(error),
);

export default jsRequest;
